import React from "react";
import Select from "react-select";
import PropTypes from 'prop-types';

import Static from "../../lib/Static";
import style from "./Filters.css";

const Filters = ({ selectedDeptId, selectedOfficeId, filterForRemote, onFilterChange }) => {
  const allDepartments = [{
    label: "All Teams",
    value: -1
  }].concat(Static.teams.map((item, idx) => {
    return {
      label: item.name,
      value: idx
    };
  }));

  const allOffices = [{
    label: "All Locations",
    value: -1
  }].concat(Static.offices.map((office, idx) => {
    return {
      label: office.name,
      value: idx
    };
  }));

  return (
    <div className={style.filters}>
      <Select
        className={style.select}
        value={selectedDeptId}
        options={allDepartments}
        clearable={false}
        onChange={(item) => {
          onFilterChange("department", item ? item.value : null);
        }}
      />
      <Select
        className={style.select}
        value={selectedOfficeId}
        options={allOffices}
        clearable={false}
        onChange={(item) => {
          onFilterChange("office", item ? item.value : null);
        }}
      />
      <div style={{
        display: "flex",
        alignItems: "center",
      }}>
        <input
          type={"checkbox"}
          id={"remoteFilter"}
          style={{height: "20px", width: "20px" }}
          checked={filterForRemote}
          onChange={(event) => onFilterChange("remote", event.currentTarget.checked)}
        />
        <label style={{ marginLeft: "8px" }} htmlFor={"remoteFilter"}>Remote Only</label>
      </div>
    </div>
  );
};

Filters.propTypes = {
  selectedOfficeId: PropTypes.number,
  selectedDeptId: PropTypes.number,
  filterForRemote: PropTypes.bool,
  onFilterChange: PropTypes.func.isRequired
};

export default Filters;



// WEBPACK FOOTER //
// ./component/CurrentOpenings/Filters.js